// @flow
import { createAction } from 'redux-actions'
import { SA, MA } from '@prohabits/metaverse'
import { createRequestActions as request } from 'store/actionCreators'
import { PROTRACKS_PUBLIC_PATH } from 'app/constants/api/protracks'
import { CREATE_PROTRACK_FORM_NAME } from 'app/constants/protracks'

export const getAllProtracks = request('PROTRACKS/GET_ALL', () => ({
  request: {
    url: '/protracks',
  },
}))

export const getPublishedProtracks = request(
  'PROTRACKS/GET_PUBLISHED',
  ({ isSuperAdmin, organizationId }: { isSuperAdmin: string, organizationId: number }) => {
    const pathMA = `${MA}/${organizationId}`
    return {
      request: {
        url: `/protracks/published/${isSuperAdmin ? SA : pathMA}`,
      },
    }
  }
)

export const fetchPublishedProTracksLibraries = request('PROTRACKS/FETCH_PUBLISHED_LIBRARIES', () => ({
  request: {
    url: '/protracks/published/libraries',
  },
}))

export const fetchPublicProTracks = request('PROTRACKS/GET_EXTERNAL_PROTRACKS', () => ({
  request: {
    url: PROTRACKS_PUBLIC_PATH,
  },
}))

export const createPublicProTrack = request('PUBLIC_PROTRACKS/CREATE', label => ({
  request: {
    url: PROTRACKS_PUBLIC_PATH,
    method: 'POST',
    data: { name: label && label.trim() },
  },
  success: 'Public ProTrack successfully created',
}))

export const deletePublicProTrack = request('PUBLIC_PROTRACKS/DELETE', proTrackId => ({
  request: {
    url: `/protracks-public/${proTrackId}`,
    method: 'DELETE',
  },
  proTrackId,
  success: 'Public ProTrack successfully deleted',
}))

export const getProtrackById = request('PROTRACKS/GET_BY_ID', id => ({
  request: {
    url: `/protracks/${id}`,
  },
}))

export const postProtrack = request('PROTRACKS/POST', (values, shouldLeavePage = true) => ({
  request: {
    url: '/protracks',
    method: 'POST',
    data: values,
  },
  form: CREATE_PROTRACK_FORM_NAME,
  shouldLeavePage,
}))

export const deleteProTrack = request('PROTRACKS/DELETE', proTrackId => ({
  request: {
    url: `/protracks/${proTrackId}`,
    method: 'Delete',
  },
  success: 'ProTrack was removed successfully',
}))

export const triggerPutProtrack = createAction('PROTRACKS/TRIGGER_PUT', (values, shouldLeavePage = true) => ({
  values,
  shouldLeavePage,
}))

export const putProtrack = request('PROTRACKS/PUT', ({ protrackId, data, shouldLeavePage }) => ({
  request: {
    url: `/protracks/${protrackId}`,
    method: 'PUT',
    data,
  },
  shouldLeavePage,
}))

export const setView = createAction('PROTRACKS/SET_VIEW', id => ({
  id,
}))

export const selectPage = createAction('PROTRACKS/SELECT_PAGE', page => ({
  page,
}))

export const sortBy = createAction('PROTRACKS/SORT_BY', (by, desc) => ({
  by,
  desc,
}))

export const filterBy = createAction('PROTRACKS/FILTER_BY', by => ({
  by,
}))

export const filterLibrariesBy = createAction('PROTRACKS/FILTER_LIBRARIES_BY', by => ({
  by,
}))

export const uploadImageRequest = createAction(
  'PROTRACKS/IMAGE_UPLOAD_REQUEST',
  (file: File | HTMLCanvasElement, mime: string, ext: string, fileFieldName: string = 'image') => ({
    file,
    mime,
    ext,
    fileFieldName,
  })
)

export const selectPublicProtrack = createAction('PROTRACKS/SELECT_EXTERNAL_PROTRACK', id => ({
  id,
}))

export const cloneProTrack = request('PROTRACKS/CLONE_PROTRACK', values => ({
  request: {
    url: '/protracks/clone',
    method: 'POST',
    data: values,
  },
  success: 'ProTrack cloned successfully',
}))

export const getProTrackOrganizationUsersEmails = request(
  'PROTRACKS/GET_PROTRACK_ORGANIZATION_USERS_EMAILS',
  ({ organizationId, proTrackLevelId }) => ({
    request: {
      url: `/protracks/${organizationId}/${proTrackLevelId}/usersEmails`,
      method: 'GET',
    },
    fail: 'User list request failed',
  })
)
